import { DotLegalRadioButton, DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { RadioGroup, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { OperationCriticalityLevelEnum } from "../../../system/systemEdit/SystemEdit.types.ts";
import DotLegalStepHeader from "../../../common/components/dotLegalStepHeader/DotLegalStepHeader.tsx";
import { isNullOrWhitespace } from "../../../common/stringOperations.ts";

export interface SystemIsCriticalForOperationFieldProps {
    isCriticalForOperation: boolean;
    criticalityLevel: OperationCriticalityLevelEnum | undefined;
    onIsCriticalForOperationChange: (isCritical: boolean) => void;
    onCriticalityLevelChange: (level: OperationCriticalityLevelEnum | undefined) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function SystemIsCriticalForOperationField(props: SystemIsCriticalForOperationFieldProps) {
    const { translateString, translateOperationCriticalityLevelEnum } = useTranslation();

    const levelOfCriticalityOptions = [
        { id: OperationCriticalityLevelEnum.VeryLow.toString(), name: translateOperationCriticalityLevelEnum(OperationCriticalityLevelEnum.VeryLow) },
        { id: OperationCriticalityLevelEnum.Low.toString(), name: translateOperationCriticalityLevelEnum(OperationCriticalityLevelEnum.Low) },
        { id: OperationCriticalityLevelEnum.Moderate.toString(), name: translateOperationCriticalityLevelEnum(OperationCriticalityLevelEnum.Moderate) },
        { id: OperationCriticalityLevelEnum.High.toString(), name: translateOperationCriticalityLevelEnum(OperationCriticalityLevelEnum.High) },
        { id: OperationCriticalityLevelEnum.VeryHigh.toString(), name: translateOperationCriticalityLevelEnum(OperationCriticalityLevelEnum.VeryHigh) },
    ];

    const showCriticalityLevel = props.isPreview || props.isCriticalForOperation;

    return (
        <>
            <DotLegalSelect
                options={[
                    { id: "0", name: translateString("no") },
                    { id: "1", name: translateString("yes") },
                ]}
                onChange={
                    props.readOnly
                        ? () => {}
                        : (value) => {
                              props.onIsCriticalForOperationChange(value === "1");
                          }
                }
                label={translateString("operationCriticalSystem")}
                noOptionsLabel={translateString("noOptions")}
                selectedItem={props.isCriticalForOperation ? "1" : "0"}
                disableClearable
                disabled={props.disabled}
                errorText={props.errorText}
            />

            {showCriticalityLevel && (
                <DotLegalSelect
                    options={levelOfCriticalityOptions}
                    onChange={
                        props.readOnly
                            ? () => {}
                            : (value) => {
                                  if (isNullOrWhitespace(value ?? undefined)) {
                                      props.onCriticalityLevelChange(undefined);
                                  } else {
                                      props.onCriticalityLevelChange(Number(value) as OperationCriticalityLevelEnum);
                                  }
                              }
                    }
                    label={translateString("levelOfCriticality")}
                    noOptionsLabel={translateString("noOptions")}
                    selectedItem={props.criticalityLevel?.toString()}
                    disableClearable
                    disabled={props.disabled}
                    errorText={props.errorText}
                />
            )}
        </>
    );
}

export default SystemIsCriticalForOperationField;
